export const apiBaseUrl = process.env.REACT_APP_SERVER;
